import { ILocationWarningType } from 'redux-state/weather-warnings/types.js';
import { getWarningsForDay } from 'utilities/weather-warnings/warning-intervals.js';
import { LoadedWarningsByLocationHook } from '../../../utilities/weather-warnings/hooks/use-warnings-location-loaded.js';
import { IForecastDayList, IForecastDayTab } from '../types.js';

/** Merges warnings into days to display in city forecast layouts */
export const CityForecastWarningsHook = (
  propDays: Array<IForecastDayTab<'Raw'> | IForecastDayList<'Raw'>>,
  configLocation?: Partial<ILocationWarningType>,
): IForecastDayTab<'Warnings'>[] => {
  const warningsForLoc = LoadedWarningsByLocationHook({ locationOverride: configLocation });
  const days = propDays.map((day) => {
    const dayWarnings = getWarningsForDay(new Date(day.date), warningsForLoc?.warnings);
    return {
      ...day,
      warnings: dayWarnings,
    };
  });
  return days;
};
